import { Button, Flex, HStack, IconButton, Text, Tooltip, useDisclosure } from '@chakra-ui/react';
import { useStatsigClient } from '@statsig/react-bindings';

import {
  SFBookmarkFilledIcon,
  SFBookmarkIcon,
  SFEyeIcon,
  SFEyeSlashIcon,
  SFSquareArrowUp
} from '@assets/icons';
import { useBreakpoints } from '@util/hooks';
import ShareMeetingModal from '@components/meeting/share-meeting-modal.component';
import CollectionsMenu from '@components/collection/collections-menu.component';

const CardActions = ({
  card,
  onCardActionClick,
  isHovering,
  isMobile,
  showBody,
  shareMeetingDisclosure,
  enableCollections = true
}) => {
  const { checkGate } = useStatsigClient();
  const enableCollectionsStatsig = checkGate('collections');
  enableCollections = enableCollections && enableCollectionsStatsig;

  const collectionsMenuDisclosure = useDisclosure();
  const showActions =
    isHovering || isMobile || (!isMobile && !showBody) || collectionsMenuDisclosure.isOpen;
  const opacity = showActions ? 1 : 0;
  return (
    <HStack
      data-testid='card-actions'
      minH={7}
      align='end'
      justify={{ base: 'initial', md: 'flex-end' }}
      gap={{ base: 1, sm: 2 }}
    >
      {card?.source === 'Meeting' && (
        <ShareMeetingModal
          meeting={card?.source_data}
          bot={{ id: card?.source_data?.bot_id }}
          showSharedSummary
          customDisclosure={shareMeetingDisclosure}
          openButton={
            <CardAction
              opacity={opacity}
              icon={<SFSquareArrowUp boxSize={5} />}
              label='Share'
            />
          }
        />
      )}
      {enableCollections && (
        <CollectionsMenu
          cards={[card]}
          opacity={opacity}
          disclosure={collectionsMenuDisclosure}
        />
      )}
      <CardAction
        opacity={opacity}
        icon={card?.preferred ? <SFBookmarkFilledIcon /> : <SFBookmarkIcon />}
        label={card?.preferred ? 'Saved' : 'Save'}
        onClick={() => onCardActionClick('save', !card?.preferred, card)}
      />
      <CardAction
        opacity={opacity}
        icon={card?.archived ? <SFEyeIcon boxSize={5} /> : <SFEyeSlashIcon boxSize={5} />}
        label={card?.archived ? 'Unarchive' : 'Archive'}
        showLabelOnMobile={false}
        ml={{ base: 'auto', sm: 0 }}
        onClick={() => onCardActionClick('archive', !card?.archived, card)}
      />
    </HStack>
  );
};

function CardAction({ icon, label, showLabelOnMobile = true, onClick, ...containerProps }) {
  const { isMobile } = useBreakpoints();
  const sharedProps = {
    variant: 'reskinGhost',
    colorScheme: 'surface',
    size: 'reskinSm',
    onClick
  };

  return (
    <Tooltip
      label={label}
      isDisabled={isMobile || !label}
      openDelay={500}
      hasArrow
    >
      <Flex
        alignItems='center'
        {...containerProps}
      >
        {isMobile && showLabelOnMobile ? (
          <Button
            {...sharedProps}
            leftIcon={icon}
            iconSpacing={{ base: 0.5, md: 1 }}
            px={{ base: 1, md: 2 }}
          >
            <Text variant='label-reg-md'>{label}</Text>
          </Button>
        ) : (
          <IconButton
            {...sharedProps}
            px={1}
            isRound
            icon={icon}
          />
        )}
      </Flex>
    </Tooltip>
  );
}

export default CardActions;
